import { createContext, FC, useContext } from 'react';
import styled from 'styled-components';
import { colors, fonts } from 'ui/theme';

type Column = {
  id: string;
  width: string;
};

const ColumnsContext = createContext<Column[]>([]);

export const useColumns = () => useContext(ColumnsContext);

const TableWrapper = styled.div`
  display: grid;
  grid-template-columns: ${() =>
    useColumns()
      .map(({ id, width }) => `[col-${id}] ${width}`)
      .join(' ')};
  align-items: stretch;
  font-family: ${fonts.sansSerif};
  background-color: ${colors.white};
`;

type TableProps = {
  columns: Column[];
};

export const Table: FC<React.PropsWithChildren<TableProps>> = ({ columns, children }) => (
  <ColumnsContext.Provider value={columns}>
    <TableWrapper>{children}</TableWrapper>
  </ColumnsContext.Provider>
);
